import { render, staticRenderFns } from "./Form.Appointment.vue?vue&type=template&id=4907e23a&scoped=true"
import script from "./Form.Appointment.vue?vue&type=script&lang=js"
export * from "./Form.Appointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4907e23a",
  null
  
)

export default component.exports